import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import SelectWrap from "../../../../components/SelectWrap";

class AddForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            affid: '',
            subids: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px", overflow: 'visible' }}>
                    <SelectWrap
                        values={this.props.affids}
                        label="Affid:"
                        name="affid"
                        onChange={this.handleFieldChange}
                        value={this.state.affid}
                        required
                    />
                    <FieldGroup
                        name="subids"
                        label="Subids:"
                        onChange={this.handleFieldChange}
                        value={this.state.subids}
                        required
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default AddForm;


// WEBPACK FOOTER //
// ./src/scenes/AdkBlock/components/AddForm/index.js